// extracted by mini-css-extract-plugin
export default {"containerError":"Error_containerError__krQ5k","num":"Error_num__p+BDq","pagenotfound":"Error_pagenotfound__nsIIh","btn":"Error_btn__ihHjd"};